<template>
    <div class="minusplusnumber my-10">
        <button class="mpbtn minus" :disabled="minusDisabled" @click="mpminus()">-</button>
        <div id="field_container">
            <input v-money="money" :value="value" inputmode="numeric" />
        </div>
        <button class="mpbtn plus" :disabled="addDisabled" @click="mpplus()">+</button>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Number,
                default: 4500,
            },
            min: {
                type: Number,
                default: 0,
            },
            max: {
                type: Number,
                default: undefined,
            },
        },
        data() {
            return {
                money: {
                    thousands: ",",
                    prefix: "$",
                    precision: 0,
                    masked: false,
                },
            }
        },
        computed: {
            addDisabled() {
                return this.value > 4000 // or === 0
            },
            minusDisabled() {
                return this.value < 1500 // or === 0
            },
        },

        methods: {
            getNotificationClass(notification) {
                return `alert alert-${notification.type}`
            },

            mpplus: function(value) {
                this.$emit("input", this.value + 500)
            },

            mpminus: function() {
                this.$emit("input", this.value - 500)
            },
        },
    }
</script>
<style lang="scss" scoped>
    .minusplusnumber {
        border-radius: 5px;
        background-color: #fff;
        margin: 0 5px 0 5px;
        display: flex;
        user-select: none;
        max-width: 333px;
        margin: auto;
    }

    .minusplusnumber div {
        display: flex;
        align-items: center;
    }

    .minusplusnumber #field_container input {
        width: 220px;
        text-align: center;
        font-size: 15px;
        border: none;
        height: 25px;
        border: 2px solid $grey-darken-1;
    }

    .minusplusnumber .mpbtn {
        background-color: #002855;
        font-size: 2rem;
        color: #fff;
        height: 56px;
        width: 56px;
        cursor: pointer;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .minusplusnumber .mpbtn:hover {
        background-color: #ddd;
        color: #002855;
    }

    .minusplusnumber .mpbtn.plus {
        &[disabled] {
            background: lighten($color: #e0e0e0, $amount: 5%);
            color: rgb(175, 175, 175);
        }
    }

    .minusplusnumber .mpbtn:active {
        background-color: #c5c5c5;
    }
</style>
